import React, { useEffect, useState } from "react";
import IconClose from "../Resources/svg/Icons/IconClose";
import Button from "./FormElements/Button";

export default function ModalConfirmation({
  open,
  setOpen,
  title,
  message = "",
  acceptCallback,
  acceptButtonTitle = "Aceptar",
}) {
  const [loadingClick, setLoadingClick] = useState(false);

  const cancelButton = () => {
    setOpen(false);
  };

  const acceptButton = () => {
    setOpen(false);
    acceptCallback();
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  return (
    <div
      className={
        "modal-filtering modal-result is-midle modal-confirmation" +
        (open ? " is-open" : "")
      }
    >
      <div className="modal-filtering__box">
        <div className="modal-filtering__close" onClick={() => setOpen(false)}>
          <IconClose />
        </div>
        <div className="modal-filtering__body">
          <div className="wrap">
            <div className="modal-filterin__inner">
              <h2 className="modal-result__title">{title}</h2>
              <div className="modal-result__content">
                <div className="modal-result__desc">{message}</div>
                <div className="actions">
                  <Button
                    className={`${
                      loadingClick ? "is-loading" : ""
                    } actions__continue`}
                    onClick={() => acceptButton()}
                  >
                    {acceptButtonTitle}
                  </Button>
                  <Button
                    className="is-secondary actions__cancel"
                    onClick={() => cancelButton()}
                    disabled={loadingClick ? true : false}
                  >
                    Cancelar
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
